<template>
  <div class="container">
    <RoomProvider></RoomProvider>
    <BookingProvider :date="date"></BookingProvider>
    <div class="toolbar">
      <GoBackButton class="back-button"></GoBackButton>
      <h2>Uusi varaus</h2>
    </div>
    <div v-if="doneLoading">
      <BookingEditForm :booking="newBooking" @change="onChange()"></BookingEditForm>
      <span v-if="error" class="error">Tila on jo varattu välillä {{overlap.start}} - {{overlap.end}}</span>
      <button class="btn" @click="onSave()">Tallenna</button>
      <div v-if="saving">Tallennetaan...</div>
    </div>
    <div v-else>
      Ladataan...
    </div>
  </div>
</template>

<script>

import RoomProvider from '@/components/providers/RoomProvider'
import BookingProvider from '@/components/providers/BookingProvider'
import BookingEditForm from '@/components/BookingEditForm'
import GoBackButton from '@/components/GoBackButton'
import TimeUtils from '@/utils/TimeUtils'
import { mapGetters, mapActions } from 'vuex';
import { getClaim } from './../utils/cognito';

import types from '@/store/types'
import Booking from './../store/modules/booking/types'

export default {
  name: 'BookingCreateView',
  components: { RoomProvider, BookingProvider, BookingEditForm, GoBackButton },
  data () {
    return {
      newBooking: {
      },
      error: false,
      overlap: undefined
    }
  },
  computed: {
    saving () {
      return this.getCreateStatus() === 'pending'
    },
    doneLoading () {
      return this.room && this.day
    },
    booking () {
      return {
        title: '',
        user: this.user,
        date: this.date,
        start: this.start,
        end: this.end,
        roomId: this.roomId,
      }
    },
    user () {
      const user = getClaim('name');
      return user;
    },
    date () {
      return this.$route.params.date;
    },
    start () {
      return this.$route.params.startTime || '8:00';
    },
    end () {
      return TimeUtils.addHours(this.start, 1);
    },
    roomId () {
      return this.$route.params.room;
    },
    room () {
      return this.getRoomById(this.roomId);
    },
    day () {
      return this.getDayByRoom(this.date, this.roomId)
    },
    ...mapGetters('Room', ['getRoomById']),
    ...mapGetters('Booking', [
      Booking.getters.GET_DAY_BY_ROOM,
      Booking.getters.GET_CREATE_STATUS
    ])
  },
  methods: {
    checkOverlap () {
      if (this.day) {
        let found;
        const toCreate = this.newBooking;
        let overlaps = this.day.some((b) => {
          const isOverlapping = TimeUtils.timesOverlap(b.start, b.end, toCreate.start, toCreate.end)
          found = isOverlapping ? b : undefined;
          return isOverlapping;
        });
        this.overlap = overlaps ? {start: found.start, end: found.end} : undefined;
        this.error = overlaps;
      }
    },
    onChange () {
      this.checkOverlap();
    },
    onSave () {
      if (!this.error) {
        this.createBooking(this.newBooking).then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.checkOverlap();
        });
      }
    },
    ...mapActions('Booking', [Booking.actions.CREATE_BOOKING])
  },
  created () {
    this.newBooking = {...this.booking};
    this.checkOverlap();
  }
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';
@import 'src/values.scss';

  .container {
    padding: 1em;
  }

  .toolbar {

    margin-bottom: 1em;
    padding-bottom: 0.2em;
    border-bottom: 1px solid $primary-dark;

    .back-button {
      float: left;
    }
    h2 {
      display: inline-block;
    }
  }

  .btn {
    padding: 0.3em 0.8em;
    //border-radius: 0.5em;
    //background: linear-gradient($secondary-light, $secondary);
    background: $secondary;
    color: $secondary-text;
    display: block;
    margin: 0 auto;
    font-size: 110%;
    font-weight: bold;
    border: none;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }

  button.btn {
    margin-top: 0.5em;
  }

  h2 {
    margin: 0;
  }

  .back-button {
    display: inline-block;
    // margin-left: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/BookingCreateView.vue